export class Ethnicity {
    name: string;
    id: number;
    code: string;
}